module.exports = __webpack_public_path__ + "static/media/lalashan1.e3b00efa.jpg";